<div class="body" *transloco="let t">
  <div class="main-font frequency-header">
    <div class="head-type">{{ t('AUDIT-SETUP-PAGE.FREQUENCY-VIEW.HEADER.TITLE') }}</div>
    <div class="small-head-type">{{ t('AUDIT-SETUP-PAGE.FREQUENCY-VIEW.HEADER.SUBTITLE') }}</div>
  </div>
  <div class="freq-button-container">
    <button [class.freq_click]="selectedFrequency === prevalence.Daily" class="freq-button" (click)="selectType(prevalence.Daily)">
      <img src="/assets/daily.svg" alt="Daily">
      <div class="body-emphasized">{{ t('COMMON.LABEL.DAILY') }}</div>
      <div class="description">{{ t('AUDIT-SETUP-PAGE.FREQUENCY-VIEW.OPTIONS.DAILY.DESC') }}</div>
    </button>
    <button [class.freq_click]="selectedFrequency === prevalence.Weekly" class="freq-button" (click)="selectType(prevalence.Weekly)">
      <img src="/assets/weekly.svg" alt="Weekly">
      <div class="body-emphasized">{{ t('COMMON.LABEL.WEEKLY') }}</div>
      <div class="description" [innerHTML]="t('AUDIT-SETUP-PAGE.FREQUENCY-VIEW.OPTIONS.WEEKLY.DESC-HTML')"></div>
    </button>
    <button [class.freq_click]="selectedFrequency === prevalence.Monthly" class="freq-button" (click)="selectType(prevalence.Monthly)">
      <img src="/assets/monthly.svg" alt="Monthly">
      <div class="body-emphasized">{{ t('COMMON.LABEL.MONTHLY') }}</div>
      <div class="description" [innerHTML]="t('AUDIT-SETUP-PAGE.FREQUENCY-VIEW.OPTIONS.MONTHLY.DESC-HTML')"></div>
    </button>
    <button [class.freq_click]="selectedFrequency === prevalence.Quarterly" class="freq-button" (click)="selectType(prevalence.Quarterly)">
      <img src="/assets/quarter.svg" alt="Quarterly">
      <div class="body-emphasized">{{ t('COMMON.LABEL.QUARTERLY') }}</div>
      <div class="description">{{ t('AUDIT-SETUP-PAGE.FREQUENCY-VIEW.OPTIONS.QUARTERLY.DESC') }}</div>
    </button>
  </div>
  <div *ngIf="showErrorMessage && !isValid" class="error">
    <img src="/assets/warning.png">
    <p>{{ t('VALIDATION.ERROR-MSG') }}</p>
  </div>
  <div class="star-desc">
    <div class="small-head-type-star">
      * <span class="next-to-star">
      {{ t('AUDIT-SETUP-PAGE.FREQUENCY-VIEW.FOOTNOTE') }}
      </span>
    </div>
  </div>
  <div class="space"></div>
</div>
